import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import './bigImpacts.scss';

// Import static assets
import BigImageLogo from '../../public/images/sip-select/bigImpact/big_impact_logo.svg';
import OrangeLine from '../../public/images/sip-select/bigImpact/orange_line.svg';

// Import Education Images
import JanEducationImage from '../../public/images/sip-select/bigImpact/education/jan_education.png';
import FebEducationImage from '../../public/images/sip-select/bigImpact/education/feb_education.png';
import MarEducationImage from '../../public/images/sip-select/bigImpact/education/mar_education.png';
import AprEducationImage from '../../public/images/sip-select/bigImpact/education/apr_education.png';
import MayEducationImage from '../../public/images/sip-select/bigImpact/education/may_education.png';
import JunEducationImage from '../../public/images/sip-select/bigImpact/education/jun_education.png';
import JulEducationImage from '../../public/images/sip-select/bigImpact/education/jul_education.png';
import AugEducationImage from '../../public/images/sip-select/bigImpact/education/aug_education.png';
import SepEducationImage from '../../public/images/sip-select/bigImpact/education/sep_education.png';
import OctEducationImage from '../../public/images/sip-select/bigImpact/education/oct_education.png';
import NovEducationImage from '../../public/images/sip-select/bigImpact/education/nov_education.png';
import DecEducationImage from '../../public/images/sip-select/bigImpact/education/dec_education.png';

// Import Animals Images
import JanAnimalsImage from '../../public/images/sip-select/bigImpact/animals/jan_animals.png';
import FebAnimalsImage from '../../public/images/sip-select/bigImpact/animals/feb_animals.png';
import MarAnimalsImage from '../../public/images/sip-select/bigImpact/animals/mar_animals.png';
import AprAnimalsImage from '../../public/images/sip-select/bigImpact/animals/apr_animals.png';
import MayAnimalsImage from '../../public/images/sip-select/bigImpact/animals/may_animals.png';
import JunAnimalsImage from '../../public/images/sip-select/bigImpact/animals/jun_animals.png';
import JulAnimalsImage from '../../public/images/sip-select/bigImpact/animals/jul_animals.png';
import AugAnimalsImage from '../../public/images/sip-select/bigImpact/animals/aug_animals.png';
import SepAnimalsImage from '../../public/images/sip-select/bigImpact/animals/sep_animals.png';
import OctAnimalsImage from '../../public/images/sip-select/bigImpact/animals/oct_animals.png';
import NovAnimalsImage from '../../public/images/sip-select/bigImpact/animals/nov_animals.png';
import DecAnimalsImage from '../../public/images/sip-select/bigImpact/animals/dec_animals.png';

// Import Women & Girls Images
import JanWomenGirlsImage from '../../public/images/sip-select/bigImpact/women_girls/jan_women_girls.png';
import FebWomenGirlsImage from '../../public/images/sip-select/bigImpact/women_girls/feb_women_girls.png';
import MarWomenGirlsImage from '../../public/images/sip-select/bigImpact/women_girls/mar_women_girls.png';
import AprWomenGirlsImage from '../../public/images/sip-select/bigImpact/women_girls/apr_women_girls.png';
import MayWomenGirlsImage from '../../public/images/sip-select/bigImpact/women_girls/may_women_girls.png';
import JunWomenGirlsImage from '../../public/images/sip-select/bigImpact/women_girls/jun_women_girls.png';
import JulWomenGirlsImage from '../../public/images/sip-select/bigImpact/women_girls/jul_women_girls.png';
import AugWomenGirlsImage from '../../public/images/sip-select/bigImpact/women_girls/aug_women_girls.png';
import SepWomenGirlsImage from '../../public/images/sip-select/bigImpact/women_girls/sep_women_girls.png';
import OctWomenGirlsImage from '../../public/images/sip-select/bigImpact/women_girls/oct_women_girls.png';
import NovWomenGirlsImage from '../../public/images/sip-select/bigImpact/women_girls/nov_women_girls.png';
import DecWomenGirlsImage from '../../public/images/sip-select/bigImpact/women_girls/dec_women_girls.png';

// Import Food & Hunger Images
import JanFoodHungerImage from '../../public/images/sip-select/bigImpact/food_hunger/jan_food_hunger.png';
import FebFoodHungerImage from '../../public/images/sip-select/bigImpact/food_hunger/feb_food_hunger.png';
import MarFoodHungerImage from '../../public/images/sip-select/bigImpact/food_hunger/mar_food_hunger.png';
import AprFoodHungerImage from '../../public/images/sip-select/bigImpact/food_hunger/apr_food_hunger.png';
import MayFoodHungerImage from '../../public/images/sip-select/bigImpact/food_hunger/may_food_hunger.png';
import JunFoodHungerImage from '../../public/images/sip-select/bigImpact/food_hunger/jun_food_hunger.png';
import JulFoodHungerImage from '../../public/images/sip-select/bigImpact/food_hunger/jul_food_hunger.png';
import AugFoodHungerImage from '../../public/images/sip-select/bigImpact/food_hunger/aug_food_hunger.png';
import SepFoodHungerImage from '../../public/images/sip-select/bigImpact/food_hunger/sep_food_hunger.png';
import OctFoodHungerImage from '../../public/images/sip-select/bigImpact/food_hunger/oct_food_hunger.png';
import NovFoodHungerImage from '../../public/images/sip-select/bigImpact/food_hunger/nov_food_hunger.png';
import DecFoodHungerImage from '../../public/images/sip-select/bigImpact/food_hunger/dec_food_hunger.png';

// Import Medical Images
import JanMedicalImage from '../../public/images/sip-select/bigImpact/medical/jan_medical.png';
import FebMedicalImage from '../../public/images/sip-select/bigImpact/medical/feb_medical.png';
import MarMedicalImage from '../../public/images/sip-select/bigImpact/medical/mar_medical.png';
import AprMedicalImage from '../../public/images/sip-select/bigImpact/medical/apr_medical.png';
import MayMedicalImage from '../../public/images/sip-select/bigImpact/medical/may_medical.png';
import JunMedicalImage from '../../public/images/sip-select/bigImpact/medical/jun_medical.png';
import JulMedicalImage from '../../public/images/sip-select/bigImpact/medical/jul_medical.png';
import AugMedicalImage from '../../public/images/sip-select/bigImpact/medical/aug_medical.png';
import SepMedicalImage from '../../public/images/sip-select/bigImpact/medical/sep_medical.png';
import OctMedicalImage from '../../public/images/sip-select/bigImpact/medical/oct_medical.png';
import NovMedicalImage from '../../public/images/sip-select/bigImpact/medical/nov_medical.png';
import DecMedicalImage from '../../public/images/sip-select/bigImpact/medical/dec_medical.png';

// Import Widow Support Images
import JanWidowImage from '../../public/images/sip-select/bigImpact/widow/jan_widow.png';
import FebWidowImage from '../../public/images/sip-select/bigImpact/widow/feb_widow.png';
import MarWidowImage from '../../public/images/sip-select/bigImpact/widow/mar_widow.png';
import AprWidowImage from '../../public/images/sip-select/bigImpact/widow/apr_widow.png';
import MayWidowImage from '../../public/images/sip-select/bigImpact/widow/may_widow.png';
import JunWidowImage from '../../public/images/sip-select/bigImpact/widow/jun_widow.png';
import JulWidowImage from '../../public/images/sip-select/bigImpact/widow/jul_widow.png';
import AugWidowImage from '../../public/images/sip-select/bigImpact/widow/aug_widow.png';
import SepWidowImage from '../../public/images/sip-select/bigImpact/widow/sep_widow.png';
import OctWidowImage from '../../public/images/sip-select/bigImpact/widow/oct_widow.png';
import NovWidowImage from '../../public/images/sip-select/bigImpact/widow/nov_widow.png';
import DecWidowImage from '../../public/images/sip-select/bigImpact/widow/dec_widow.png';

// Import Elderly Care Images
import JanElderlyImage from '../../public/images/sip-select/bigImpact/elderly/jan_elderly.png';
import FebElderlyImage from '../../public/images/sip-select/bigImpact/elderly/feb_elderly.png';
import MarElderlyImage from '../../public/images/sip-select/bigImpact/elderly/mar_elderly.png';
import AprElderlyImage from '../../public/images/sip-select/bigImpact/elderly/apr_elderly.png';
import MayElderlyImage from '../../public/images/sip-select/bigImpact/elderly/may_elderly.png';
import JunElderlyImage from '../../public/images/sip-select/bigImpact/elderly/jun_elderly.png';
import JulElderlyImage from '../../public/images/sip-select/bigImpact/elderly/jul_elderly.png';
import AugElderlyImage from '../../public/images/sip-select/bigImpact/elderly/aug_elderly.png';
import SepElderlyImage from '../../public/images/sip-select/bigImpact/elderly/sep_elderly.png';
import OctElderlyImage from '../../public/images/sip-select/bigImpact/elderly/oct_elderly.png';
import NovElderlyImage from '../../public/images/sip-select/bigImpact/elderly/nov_elderly.png';
import DecElderlyImage from '../../public/images/sip-select/bigImpact/elderly/dec_elderly.png';

// Import Acid Victims Support Images
import JanAcidVictimsImage from '../../public/images/sip-select/bigImpact/acid_victims/jan_acid_victims.png';
import FebAcidVictimsImage from '../../public/images/sip-select/bigImpact/acid_victims/feb_acid_victims.png';
import MarAcidVictimsImage from '../../public/images/sip-select/bigImpact/acid_victims/mar_acid_victims.png';
import AprAcidVictimsImage from '../../public/images/sip-select/bigImpact/acid_victims/apr_acid_victims.png';
import MayAcidVictimsImage from '../../public/images/sip-select/bigImpact/acid_victims/may_acid_victims.png';
import JunAcidVictimsImage from '../../public/images/sip-select/bigImpact/acid_victims/jun_acid_victims.png';
import JulAcidVictimsImage from '../../public/images/sip-select/bigImpact/acid_victims/jul_acid_victims.png';
import AugAcidVictimsImage from '../../public/images/sip-select/bigImpact/acid_victims/aug_acid_victims.png';
import SepAcidVictimsImage from '../../public/images/sip-select/bigImpact/acid_victims/sep_acid_victims.png';
import OctAcidVictimsImage from '../../public/images/sip-select/bigImpact/acid_victims/oct_acid_victims.png';
import NovAcidVictimsImage from '../../public/images/sip-select/bigImpact/acid_victims/nov_acid_victims.png';
import DecAcidVictimsImage from '../../public/images/sip-select/bigImpact/acid_victims/dec_acid_victims.png';

// Image data configuration for different causes
const causeImages = {
    education: {
        jan: { path: JanEducationImage, alt: 'Education in January' },
        feb: { path: FebEducationImage, alt: 'Education in February' },
        mar: { path: MarEducationImage, alt: 'Education in March' },
        apr: { path: AprEducationImage, alt: 'Education in April' },
        may: { path: MayEducationImage, alt: 'Education in May' },
        jun: { path: JunEducationImage, alt: 'Education in June' },
        jul: { path: JulEducationImage, alt: 'Education in July' },
        aug: { path: AugEducationImage, alt: 'Education in August' },
        sep: { path: SepEducationImage, alt: 'Education in September' },
        oct: { path: OctEducationImage, alt: 'Education in October' },
        nov: { path: NovEducationImage, alt: 'Education in November' },
        dec: { path: DecEducationImage, alt: 'Education in December' }
    },
    animals: {
        jan: { path: JanAnimalsImage, alt: 'Animals in January' },
        feb: { path: FebAnimalsImage, alt: 'Animals in February' },
        mar: { path: MarAnimalsImage, alt: 'Animals in March' },
        apr: { path: AprAnimalsImage, alt: 'Animals in April' },
        may: { path: MayAnimalsImage, alt: 'Animals in May' },
        jun: { path: JunAnimalsImage, alt: 'Animals in June' },
        jul: { path: JulAnimalsImage, alt: 'Animals in July' },
        aug: { path: AugAnimalsImage, alt: 'Animals in August' },
        sep: { path: SepAnimalsImage, alt: 'Animals in September' },
        oct: { path: OctAnimalsImage, alt: 'Animals in October' },
        nov: { path: NovAnimalsImage, alt: 'Animals in November' },
        dec: { path: DecAnimalsImage, alt: 'Animals in December' }
    },
    women_girls: {
        jan: { path: JanWomenGirlsImage, alt: 'Women empowerment in January' },
        feb: { path: FebWomenGirlsImage, alt: 'Women empowerment in February' },
        mar: { path: MarWomenGirlsImage, alt: 'Women empowerment in March' },
        apr: { path: AprWomenGirlsImage, alt: 'Women empowerment in April' },
        may: { path: MayWomenGirlsImage, alt: 'Women empowerment in May' },
        jun: { path: JunWomenGirlsImage, alt: 'Women empowerment in June' },
        jul: { path: JulWomenGirlsImage, alt: 'Women empowerment in July' },
        aug: { path: AugWomenGirlsImage, alt: 'Women empowerment in August' },
        sep: { path: SepWomenGirlsImage, alt: 'Women empowerment in September' },
        oct: { path: OctWomenGirlsImage, alt: 'Women empowerment in October' },
        nov: { path: NovWomenGirlsImage, alt: 'Women empowerment in November' },
        dec: { path: DecWomenGirlsImage, alt: 'Women empowerment in December' }
    },
    food_hunger: {
        jan: { path: JanFoodHungerImage, alt: 'Food & Hunger relief in January' },
        feb: { path: FebFoodHungerImage, alt: 'Food & Hunger relief in February' },
        mar: { path: MarFoodHungerImage, alt: 'Food & Hunger relief in March' },
        apr: { path: AprFoodHungerImage, alt: 'Food & Hunger relief in April' },
        may: { path: MayFoodHungerImage, alt: 'Food & Hunger relief in May' },
        jun: { path: JunFoodHungerImage, alt: 'Food & Hunger relief in June' },
        jul: { path: JulFoodHungerImage, alt: 'Food & Hunger relief in July' },
        aug: { path: AugFoodHungerImage, alt: 'Food & Hunger relief in August' },
        sep: { path: SepFoodHungerImage, alt: 'Food & Hunger relief in September' },
        oct: { path: OctFoodHungerImage, alt: 'Food & Hunger relief in October' },
        nov: { path: NovFoodHungerImage, alt: 'Food & Hunger relief in November' },
        dec: { path: DecFoodHungerImage, alt: 'Food & Hunger relief in December' }
    },
    medical: {
        jan: { path: JanMedicalImage, alt: 'Medical aid in January' },
        feb: { path: FebMedicalImage, alt: 'Medical aid in February' },
        mar: { path: MarMedicalImage, alt: 'Medical aid in March' },
        apr: { path: AprMedicalImage, alt: 'Medical aid in April' },
        may: { path: MayMedicalImage, alt: 'Medical aid in May' },
        jun: { path: JunMedicalImage, alt: 'Medical aid in June' },
        jul: { path: JulMedicalImage, alt: 'Medical aid in July' },
        aug: { path: AugMedicalImage, alt: 'Medical aid in August' },
        sep: { path: SepMedicalImage, alt: 'Medical aid in September' },
        oct: { path: OctMedicalImage, alt: 'Medical aid in October' },
        nov: { path: NovMedicalImage, alt: 'Medical aid in November' },
        dec: { path: DecMedicalImage, alt: 'Medical aid in December' }
    },
    widow: {
        jan: { path: JanWidowImage, alt: 'Widow support in January' },
        feb: { path: FebWidowImage, alt: 'Widow support in February' },
        mar: { path: MarWidowImage, alt: 'Widow support in March' },
        apr: { path: AprWidowImage, alt: 'Widow support in April' },
        may: { path: MayWidowImage, alt: 'Widow support in May' },
        jun: { path: JunWidowImage, alt: 'Widow support in June' },
        jul: { path: JulWidowImage, alt: 'Widow support in July' },
        aug: { path: AugWidowImage, alt: 'Widow support in August' },
        sep: { path: SepWidowImage, alt: 'Widow support in September' },
        oct: { path: OctWidowImage, alt: 'Widow support in October' },
        nov: { path: NovWidowImage, alt: 'Widow support in November' },
        dec: { path: DecWidowImage, alt: 'Widow support in December' }
    },
    elderly: {
        jan: { path: JanElderlyImage, alt: 'Elderly care in January' },
        feb: { path: FebElderlyImage, alt: 'Elderly care in February' },
        mar: { path: MarElderlyImage, alt: 'Elderly care in March' },
        apr: { path: AprElderlyImage, alt: 'Elderly care in April' },
        may: { path: MayElderlyImage, alt: 'Elderly care in May' },
        jun: { path: JunElderlyImage, alt: 'Elderly care in June' },
        jul: { path: JulElderlyImage, alt: 'Elderly care in July' },
        aug: { path: AugElderlyImage, alt: 'Elderly care in August' },
        sep: { path: SepElderlyImage, alt: 'Elderly care in September' },
        oct: { path: OctElderlyImage, alt: 'Elderly care in October' },
        nov: { path: NovElderlyImage, alt: 'Elderly care in November' },
        dec: { path: DecElderlyImage, alt: 'Elderly care in December' }
    },
    acid_victims: {
        jan: { path: JanAcidVictimsImage, alt: 'Acid attack survivors support in January' },
        feb: { path: FebAcidVictimsImage, alt: 'Acid attack survivors support in February' },
        mar: { path: MarAcidVictimsImage, alt: 'Acid attack survivors support in March' },
        apr: { path: AprAcidVictimsImage, alt: 'Acid attack survivors support in April' },
        may: { path: MayAcidVictimsImage, alt: 'Acid attack survivors support in May' },
        jun: { path: JunAcidVictimsImage, alt: 'Acid attack survivors support in June' },
        jul: { path: JulAcidVictimsImage, alt: 'Acid attack survivors support in July' },
        aug: { path: AugAcidVictimsImage, alt: 'Acid attack survivors support in August' },
        sep: { path: SepAcidVictimsImage, alt: 'Acid attack survivors support in September' },
        oct: { path: OctAcidVictimsImage, alt: 'Acid attack survivors support in October' },
        nov: { path: NovAcidVictimsImage, alt: 'Acid attack survivors support in November' },
        dec: { path: DecAcidVictimsImage, alt: 'Acid attack survivors support in December' }
    }
};

// Impact data configuration for different causes
const causeData = {
    stats: {
        count: '2.2M',
        label: 'supported'
    },
    description: 'Help make their smiles wider with your monthly donation!'
};
const BigImpacts = ({ campaign_cause = 'education' }) => {
    const [currentCause, setCurrentCause] = useState(campaign_cause);
    const [impactStats, setImpactStats] = useState({ count: '', label: '' });
    const [description, setDescription] = useState('');
    const [timelineImages, setTimelineImages] = useState({});

    useEffect(() => {
        // Update component state when cause changes
        if (typeof causeImages[campaign_cause] !== "undefined") {
            setCurrentCause(campaign_cause);
            setTimelineImages(causeImages[campaign_cause]);
            setImpactStats(causeData.stats);
            setDescription(causeData.description);
        } else {
            console.warn(`Images for campaign_cause "${campaign_cause}" not found`);
            // Fallback to education if selected campaign_cause doesn't exist
            setCurrentCause('education');
            setTimelineImages(causeImages.education);
            setImpactStats(causeData.stats);
            setDescription(causeData.description);
        }
    }, [campaign_cause]);

    const months = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];

    return (
        <>
            <div className="impact-container">
                <div className="impact-header">
                    <div className="impact-title-container">
                        <div className="impact-subtitle">small steps to make</div>
                        <div className="impact-title">
                            Big Impact
                            <div className="impact-underline">
                                <img src={OrangeLine} alt="line" />
                            </div>
                        </div>
                    </div>

                    <div className="impact-stats">
                        <div className='stats-upper-section'>
                            <div className="impact-icon">
                                <img src={BigImageLogo} alt="bigImpact" />
                            </div>
                            <p className="impact-count">{impactStats.count}</p>
                        </div>
                        <div className='stats-lower-section'>
                            <p className="impact-label">{impactStats.label}</p>
                        </div>
                    </div>
                </div>

                <div className="impact-description">
                    {description}
                </div>

                <div className="impact-timeline">
                    {months.map((month) => (
                        <div className={`timeline-item ${month}`} key={month}>
                            <img
                                loading="lazy"
                                src={timelineImages[month]?.path}
                                alt={timelineImages[month]?.alt}
                                className="timeline-image"
                            />
                            <div className='timeline-image-overlay'></div>
                            <span className="timeline-month">{month.toUpperCase()}</span>
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
};

BigImpacts.propTypes = {
    campaign_cause: PropTypes.oneOf(['education', 'animals', 'women_girls'])
};

export default BigImpacts;